module.exports = {
  STATE_STORAGE_SAVE_DURATION_IN_MINUTES: 60,
  soundDelay: 300,
  gifDelay: 500,
  MAX_UNHOVER_COUNTER: 1000,
  VOWEL_DETECTION_DELAY: 1500,
  unhoverMitigator: 3,
  accuracy: 0,
  vowelsAccuracy: {
    VOWEL_O: 0.1,
    VOWEL_U: 0
  },
  isDevMode: false
};
